import React from 'react';
import Header from '../../components/Header/index'
import BackImg from './components/BackImg/index'
import Title from './components/Title/index'

function Home() {
  return (
    <div>
      <Header/>
      <BackImg/>
      <Title/>
    </div>
  );
}

export default Home;
